/**
 * Role
 * @author ftgibran
 */

export enum Role {
  RESPONSAVEL = 'RESPONSAVEL',
  RESPONSAVEL_GROUP = 'RESPONSAVEL_GROUP',
  RESPONSAVEL_CHILD = 'RESPONSAVEL_CHILD',
  RESPONSAVEL_VIEWER = 'RESPONSAVEL_VIEWER',
  RESPONSAVEL_GROUP_MASTER = 'RESPONSAVEL_GROUP_MASTER',
  VIEWER = 'VIEWER',
  ASSOCIATE = 'ASSOCIATE',
  RASTREAMENTO = 'RASTREAMENTO',
  SAC = 'SAC',
  GUEST = 'GUEST',
}
